import React from 'react';
import ReactDOM from 'react-dom/client';

import 'tippy.js/dist/tippy.css';
import 'rsuite/dist/rsuite.min.css';
import './index.css';

import App from './App';
import reportWebVitals from './reportWebVitals';

// MSAL imports
import { PublicClientApplication, EventType, EventMessage, AuthenticationResult } from '@azure/msal-browser';
import { msalConfig } from './sso/azure/authConfig';

import { startObservability } from './observability';
import { api } from './services/api';

// Faro (Grafana): só liga com REACT_APP_FARO_API_KEY no build. Ver docs/observabilidade.md.
startObservability(api);

export const msalInstance = new PublicClientApplication(msalConfig);

// Account selection logic is app dependent. Adjust as needed for different use cases.
const accounts = msalInstance.getAllAccounts();
if (accounts.length > 0) {
  msalInstance.setActiveAccount(accounts[0]);
}

msalInstance.addEventCallback((event: EventMessage) => {
  if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
    const payload = event.payload as AuthenticationResult;
    const account = payload.account;
    msalInstance.setActiveAccount(account);
  }
});

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
// Retirando o StrictMode porque renderiza duas vezes no desenvolvimento, atrapalha em vários momentos.
// root.render(
//   <React.StrictMode>
//     <App />
//   </React.StrictMode>
// );
root.render(<App pca={msalInstance} />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
